export const routes = [
	{
		title: 'Dashboard',
		image: '/img/vectors/dashboard.svg',
		href: '/student/dashboard',
		info: 'View profile & reward stats'
	},
	{
		title: 'My Lessons',
		image: '/img/vectors/mylessons.svg',
		href: '/student/dashboard/lessons',
		info: 'View assigned lessons & ram runs'
	},
	{
		title: 'My Classes',
		image: '/img/vectors/myclasses.svg',
		href: '/student/dashboard/classes',
		info: 'View teacher assigned classes'
	},
	{
		title: 'Practice hub',
		image: '/img/vectors/ramruns.svg',
		href: '/student/dashboard/ramruns',
		info: 'View practice Ram Runs & suggested tasks'
	},
	{
		title: 'Learning Map',
		image: '/img/vectors/learningmap.svg',
		href: '/student/dashboard',
		info: 'View your progress on a personalised level  '
	},
	{
		title: 'Settings',
		image: '/img/vectors/settings.svg',
		href: '/student/dashboard/settings/account',
		info: 'Change password details & visibility'
	},
	{
		title: 'IDE',
		image: '/img/vectors/ramruns.svg',
		href: '/ide',
		info: 'Code any language freely on our editor'
	}
]




export const teacherRoutes = [
	{
		title: 'Dashboard',
		image: '/img/vectors/dashboard.svg',
		href: '/teacher/dashboard',
		info: 'View on demand info & student stats'
	},
	{
		title: 'My Curricula',
		image: '/img/vectors/mylessons.svg',
		href: '/teacher/dashboard/curricula',
		info: 'Access platform provided curriculum & create your own'
	},
	{
		title: 'My Classes',
		image: '/img/vectors/myclasses.svg',
		href: '/teacher/dashboard/classes',
		info: 'Create and manage classes, view assigned curriculums & more'
	},
	{
		title: 'My Students',
		image: '/img/vectors/ramruns.svg',
		href: '/teacher/dashboard/students',
		info: 'Create and manage students, view student progress & more'
	},
	// {
	// 	title: 'RAM Runs',
	// 	image: '/img/vectors/learningmap.svg',
	// 	href: '#'
	// },
	{
		title: 'Settings',
		image: '/img/vectors/settings.svg',
		href: '/teacher/dashboard/settings/account',
		info: 'Manage your account username, password & visibility'
	},
	{
		title: 'IDE',
		image: '/img/vectors/ramruns.svg',
		href: '/ide',
		info: 'Access our code editor for projects and more '
	}
]